<template>
  <div class="navbar">
    <h1>
      <img class="logo" src="@/assets/images/qs-logo.png" alt="logo" />
      {{ title }}
    </h1>
    <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />

    <div class="right-menu">
      <el-dropdown trigger="click">
        <div class="user_box">
          <img v-if="userInfo.sex == '女'" class="avatar" src="@/assets/images/avatar-woman.png" alt="头像" />
          <img v-else class="avatar" src="@/assets/images/avatar.png" alt="头像" />
          <div class="info">
            <div>{{ userInfo.name }}</div>
          </div>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="goUserInfo">
            <div style="font-size: 16px">
              <i class="el-icon-user"></i>
              个人信息
            </div>
          </el-dropdown-item>
          <el-dropdown-item @click.native="goChangePwd">
            <div style="font-size: 16px">
              <i class="el-icon-edit-outline"></i>
              修改密码
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <div class="icon_box" @click="handleLogout" title="退出">
        <img src="@/assets/icon/icon_out.svg" alt="退出" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Hamburger from '@/components/Hamburger';
import defaultSettings from '@/settings';

export default {
  components: {
    Hamburger
  },
  computed: {
    ...mapGetters(['sidebar', 'userInfo'])
  },
  data() {
    return {
      noticeNumber: 5,
      title: defaultSettings.title
    };
  },
  mounted() {},
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    goBigScreen() {
      const path = this.$router.resolve({ name: 'BigScreen' }).href; // 获取完整URL
      window.open(path, '_blank');
    },
    goUserInfo() {
      this.$router.push('/userInfo');
    },
    goChangePwd() {
      this.$router.push('/changePassword');
    },
    async handleLogout() {
      await this.$store.dispatch('user/logout');
      this.$router.push(`/login`);
    }
  }
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 60px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  padding: 0 20px;
  border-bottom: 1px solid #e4e7ed;

  .hamburger-container {
    float: left;
    margin: 6px 0 0 0;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  h1 {
    display: flex;
    align-items: center;
    float: left;
    font-size: 30px;
    line-height: 60px;
    margin: 0;

    .logo {
      width: 34px;
      height: 34px;
      margin-right: 4px;
    }
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 60px;
    display: flex;
    align-items: center;

    .user_box {
      position: relative;
      display: flex;
      align-items: center;
      width: 190px;
      margin: 0 10px 0 6px;
      padding: 10px;
      font-size: 18px;
      cursor: pointer;

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
      .avatar {
        width: 48px;
        height: 48px;
        margin-right: 12px;
      }
      .info {
        color: #000000;
        line-height: 30px;
        div {
          width: 98px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .mobile {
          font-size: 14px;
        }
      }
      &::after {
        position: absolute;
        right: 0;
        bottom: 0;
        transform: rotate(135deg);
        content: '';
        border: 6px solid #000000;
        border-top: 6px solid transparent;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
      }
    }
    .icon_box {
      padding: 8px;
      cursor: pointer;

      img {
        width: 26px;
        height: 26px;
      }
      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
      &.notice {
        position: relative;

        &.has_dot {
          &::after {
            content: var(--noticeNumber);
            position: absolute;
            top: 4px;
            left: 22px;
            width: 20px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            color: #ffffff;
            font-size: 14px;
            background: #f75555;
            border-radius: 50%;
          }
        }
      }
    }
  }
}
</style>
